import { useEffect } from "react";

export function usePageEffects({ key }) {
  useEffect(() => {
    if (window.fathom) {
      const locationWithKey = new URL(window.location);
      locationWithKey.pathname += `/${key}`;
      window.fathom.trackPageview({ url: locationWithKey.toString() });
    }
  }, [key]);
}
